import React from 'react';
import Skill from '../components/Skill';

function About() {
  return (
    <section id="about" className="p-5">
      <div className="container my-5">

        <div className="row justify-content-center mb-3">
          <div className="col-md-12 text-center">
            <h5><span className="id-color">About Me</span></h5>
          </div>
        </div>
        <div className="row justify-content-center mb-5">
          <div className="col-md-8 text-center">
              <p>
                I am a computer scientist from Potenza (Italy), 
                with a strong focus on full stack software development. 
                I love having new experiences and always learning from what surrounds me. 
                I have a computer and electronics background. 
                I started my career as a developer and then dedicated myself to more complex systems as senior developer and junior developers mentor. 
                I have created several software solutions for the companies I have worked for.
                Currently responsible for the company software platform.
              </p>
              <p>I love photography and sports.</p>
          </div>
        </div>

        <div className='row mb-3'>
          <div className='col-md-4 mb-3 p-3'>
            <Skill key='SD' title='Software Design' percent={95}></Skill>
          </div>
          <div className='col-md-4 mb-3 p-3'>
            <Skill key='BED' title='Back End Developer' percent={95}></Skill>
          </div>
          <div className='col-md-4 mb-3 p-3'>
            <Skill key='FED' title='Front End Developer' percent={90}></Skill>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-4 mb-3 p-3'>
            <Skill key='M' title='Marketing' percent={70}></Skill>
          </div>
          <div className='col-md-4 mb-3 p-3'>
            <Skill key='D' title='Design' percent={75}></Skill>
          </div>
          <div className='col-md-4 mb-3 p-3'>
            <Skill key='P' title='Photography' percent={80}></Skill>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;